define('modules/form_editor/views/inline_toolbar',['require','exports','module','base/view','lib/util','ldsh!../templates/inline_toolbar'],function (require, exports, module) {
  'use strict';
  var BaseView = require('base/view'),
    util = require('lib/util');

  var Controller = {
    removeDuplicateButton: function () {
      this.$('.js-duplicate').hide();
    },
    removeMoveDownButton: function () {
      this.$('.js-move-down').hide();
    },
    removeMoveUpButton: function () {
      this.$('.js-move-up').hide();
    },
  };

  module.exports = BaseView.extend({
    template: require('ldsh!../templates/inline_toolbar'),
    onRender: function () {
      var name = this.model.get('name');
      if (!!~name.indexOf('custom:login')) {
        this.removeDuplicateButton();
        this.removeMoveDownButton();
        this.removeMoveUpButton();
      }
      this.$el.i18n();
    },
  });

  util.mixin(module.exports, Controller);
});

